

import { createAction } from '@reduxjs/toolkit';


export const authenticateUserRequest = createAction('AUTHENTICATE_USER', (username, password) => {
    return {
        payload: {
            username: username,
            password: password
        }
    }
});


export const authenticateUserSuccess = createAction('AUTHENTICATE_USER_SUCCESS', data => {
    return {
        payload: {
            data
        }
    }
});

export const authenticateUserFailure = createAction('AUTHENTICATE_USER_FAILURE', data => {
    return {
        payload: {
            data
        }
    }
});

export const refreshTokenRequest = createAction('REFRESH_TOKEN_REQUEST', (username, emailAddress, refreshToken) => {
    return {
        payload: {
            username: username,
            emailAddress: emailAddress,
            refreshToken: refreshToken
        }
    }
});


export const refreshTokenRequestSuccess = createAction('REFRESH_TOKEN_REQUEST_SUCCESS', data => {
    return {
        payload: {
            data
        }
    }
});

export const refreshTokenRequestFailure = createAction('REFRESH_TOKEN_REQUEST_FAILURE', data => {
    return {
        payload: {
            data
        }
    }
});



export const resetPasswordRequest = createAction('RESET_PASSWORD_REQUEST', (oldPassword, newPassword) => {
    return {
        payload: {
            oldPassword: oldPassword,
            newPassword: newPassword
        }
    }
});


export const resetPasswordRequestSuccess = createAction('RESET_PASSWORD_REQUEST_SUCCESS', data => {
    return {
        payload: {
            data
        }
    }
});

export const resetPasswordRequestFailure = createAction('RESET_PASSWORD_REQUEST_FAILURE', data => {
    return {
        payload: {
            data
        }
    }
});

export const clearResetPasswordStatus = createAction('CLEAR_RESET_PASSWORD_RESPONSE', data => {
    return {
        payload: {
            data
        }
    }
});

export const tempPasswordRequest = createAction('TEMP_PASSWORD_REQUEST', (tokenValue, password) => {
    return {
        payload: {
            token: tokenValue,
            password: password
        }
    }
});


export const tempPasswordRequestSuccess = createAction('TEMP_PASSWORD_REQUEST_SUCCESS', data => {
    return {
        payload: {
            data
        }
    }
});

export const tempPasswordRequestFailure = createAction('TEMP_PASSWORD_REQUEST_FAILURE', data => {
    return {
        payload: {
            data
        }
    }
});


export const forgetPasswordEmailRequest = createAction('FORGET_PASSWORD_EMAIL_REQUEST', (username, password, newPassword) => {
    return {
        payload: {
            userName: username
        }
    }
});


export const forgetPasswordEmailRequestSuccess = createAction('FORGET_PASSWORD_EMAIL_REQUEST_SUCCESS', data => {
    return {
        payload: {
            data
        }
    }
});

export const forgetPasswordEmailRequestFailure = createAction('FORGET_PASSWORD_EMAIL_REQUEST_FAILURE', data => {
    return {
        payload: {
            data
        }
    }
});

export const confirmForgotPasswordRequest = createAction('CONFIRM_FORGET_PASSWORD_REQUEST', (username, password, token) => {
    return {
        payload: {
            username: username,
            password: password,
            token: token
        }
    }
});


export const confirmForgotPasswordRequestSuccess = createAction('CONFIRM_FORGET_PASSWORD_REQUEST_SUCCESS', data => {
    return {
        payload: {
            data
        }
    }
});

export const confirmForgotPasswordRequestFailure = createAction('CONFIRM_FORGET_PASSWORD_REQUEST_FAILURE', data => {
    return {
        payload: {
            data
        }
    }
});

export const confirmForgotPasswordReset = createAction('CONFIRM_FORGET_PASSWORD_RESET', data => {
    return {
        payload: {
            data
        }
    }
});

export const loadingInProgress = createAction('LOADING_IN_PROGRESS', data => {
    return {
        payload: {
            data
        }
    }
});

export const restoreUserSession = createAction('RESTORE_USER_SESSION', (tMer, cMer, rMer) => {
    return {
        payload: {
            tMer,
            cMer,
            rMer
        }
    }
})